package com.exura.components.layouts.nav

import androidx.compose.runtime.Composable
import com.exura.components.icons.InlineIcon
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier

@Composable
internal fun NavigationItemContent(
    icon: @Composable () -> Unit,
    text: String,
    isCollapsed: Boolean,
    suffix: (@Composable () -> Unit)? = null,
) {
    InlineIcon(
        modifier = Modifier.fillMaxWidth(),
        icon = icon,
    ) {
        SpanText(
            text = text,
            modifier = NavTextStyle
                .toModifier(if (isCollapsed) NavTextCollapsedVariant else null)
        )

        if (!isCollapsed) {
            Spacer()
        }

        suffix?.invoke()
    }
}
